import { render, staticRenderFns } from "./AccidentList.vue?vue&type=template&id=ccb628e0&scoped=true&"
import script from "./AccidentList.vue?vue&type=script&lang=js&"
export * from "./AccidentList.vue?vue&type=script&lang=js&"
import style0 from "./AccidentList.vue?vue&type=style&index=0&id=ccb628e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb628e0",
  null
  
)

export default component.exports